'use strict';
/*
  For use by Webpack to build single javascript file of entire app.
*/
define(["applicationStart"], function () {
});
